<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-delete-report">
		<div *ngIf="vo.totalRequestToDelete !== 0" class="app-delete-report--total-deleted">
			<mat-icon class="success" [svgIcon]="DcIcons.Check"></mat-icon>
			<span i18n="@@delete.report.totalDeleteCount">total-deleted</span>
			<span>: {{vo.totalDeleted}}</span>
		</div>

		<div *ngIf="vo.totalRequestToDelete !== 0" class="app-delete-report--total-not-deleted">
			<mat-icon class="warning" [svgIcon]="DcIcons.Warning"></mat-icon>
			<span i18n="@@delete.report.totalNotDeletedCount">total-not-deleted</span>
			<span>: {{vo.totalNotDeleted}}</span>
		</div>

		<div class="delete-msg">
			<span>{{vo.message}}</span>
		</div>

		<div *ngFor="let entry of vo.report | toArray" class="consumer-elements-container">
			<ng-container *ngIf="vo.report.size === 1">
				<span>{{entry.consumedElementLabel}}</span>
				<div *ngFor="let consumer of entry.consumedWithin" class="consumer-element">
					<a appNavigate [navigateTo]="consumer.elemUrl">{{consumer.label}}</a>
					<span>({{consumer.type}})</span>
				</div>
			</ng-container>

			<ng-container *ngIf="vo.report.size > 1">
				<div (click)="toggleReportFor(entry.consumedElementLabel)" class="consumer-element-label">
					<span id="element-to-delete">{{entry.consumedElementLabel}}</span>
					<span class="consumer-element-more-less">
						<mat-icon *ngIf="!entry.isOpen">add</mat-icon>
						<mat-icon *ngIf="entry.isOpen">remove</mat-icon>
					</span>
				</div>

				<ng-container *ngIf="entry.isOpen">
					<div *ngFor="let consumer of entry.consumedWithin" class="consumer-element">
						<a appNavigate [navigateTo]="consumer.elemUrl">{{consumer.label}}</a>
						<span>({{consumer.type}})</span>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
</app-modal>
